import { useLayoutEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import type { ReservationFormInput } from '../schema/reservationForm.schema';
import { useReservationFormMachines } from '../ReservationFormMachinesContext';

/** Keeps each trip-array field machine length aligned with `trips` in React Hook Form. */
export function TripMachineCountSync() {
  const { watch } = useFormContext<ReservationFormInput>();
  const { mainActor } = useReservationFormMachines();
  const multiLegTrips = watch('trips');
  const len = Math.max(1, multiLegTrips?.length ?? 1);

  useLayoutEffect(() => {
    mainActor.send({ type: 'SET_TRIP_COUNT', count: len });
  }, [len, mainActor]);

  return null;
}
